import React from 'react'
import Link from 'gatsby-link'
import { Container, Tabs, TabList, Tab, TabLink } from 'bloomer'

const AppHeader = () => (
  <Container>
    <Tabs isAlign="centered">
      <TabList>
        <Tab>
          <Link to="/">Home</Link>
        </Tab>
        <Tab>
          <a href="https://www.zoho.com/mail/login.html">Mail</a>
        </Tab>
      </TabList>
    </Tabs>
  </Container>
)

export default AppHeader



// WEBPACK FOOTER //
// ./src/components/Header/index.js